var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 49,
    viewBox: "0 0 39 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 27.75H23V31.25H9V27.75ZM9 19H30V22.5H9V19ZM9 36.5H17.75V40H9V36.5Z",
    fill: "#005596"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4545 5.25H30.1364V3.5C30.1364 2.57174 29.7628 1.6815 29.0979 1.02513C28.433 0.368749 27.5312 0 26.5909 0H12.4091C11.4688 0 10.567 0.368749 9.90208 1.02513C9.23717 1.6815 8.86364 2.57174 8.86364 3.5V5.25H3.54545C2.60514 5.25 1.70334 5.61875 1.03844 6.27513C0.373538 6.9315 0 7.82174 0 8.75V45.5C0 46.4283 0.373538 47.3185 1.03844 47.9749C1.70334 48.6313 2.60514 49 3.54545 49H35.4545C36.3949 49 37.2967 48.6313 37.9616 47.9749C38.6265 47.3185 39 46.4283 39 45.5V8.75C39 7.82174 38.6265 6.9315 37.9616 6.27513C37.2967 5.61875 36.3949 5.25 35.4545 5.25ZM12.4091 3.5H26.5909V10.5H12.4091V3.5ZM35.4545 45.5H3.54545V8.75H8.86364V14H30.1364V8.75H35.4545V45.5Z",
    fill: "#005596"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoReport);
export default __webpack_public_path__ + "static/media/logo-report.3d8190dd3801ea29289a5036911626a2.svg";
export { ForwardRef as ReactComponent };